<template>
  <div id="submission-update-dialog">
    <el-row :gutter="10">
      <el-col :span="24">
        <div class="registerform-input-container mt-2">
          <div class="title">
            <div>
              <label>{{$t('components.abstract.tabs.dialog.submissionDialog.title')}}</label>
              <el-tooltip content="Content" placement="bottom">
                <i class="el-icon-info"></i>
              </el-tooltip>
            </div>
          </div>
          <el-input v-model="form.title"></el-input>
        </div>
      </el-col>
      <el-col :span="24">
        <div class="registerform-input-container mt-2">
          <div class="title">
            <div>
              <label>{{$t('components.abstract.tabs.dialog.submissionDialog.details')}}</label>
              <el-tooltip content="Content" placement="bottom">
                <i class="el-icon-info"></i>
              </el-tooltip>
            </div>
          </div>
          <el-input type="textarea" :rows="4" v-model="form.details"></el-input>
        </div>
      </el-col>
      <el-col :span="24" class="d-flex justify-content-end align-items-center mt-2">
      <el-button type="danger" icon="fas fa-trash" class="mr-auto"  @click="$emit('deleteMe')" round size="mini">{{$t('components.abstract.tabs.dialog.submissionDialog.delete')}}</el-button>
        <div>
          <el-button size="mini" round type="warning" @click="$emit('closeMe')">{{$t('components.abstract.tabs.dialog.submissionDialog.close')}}</el-button>
          <el-button size="mini" round type="primary" @click="update">{{$t('components.abstract.tabs.dialog.submissionDialog.save')}}</el-button>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  props: ['data'],
  data() {
    return {
      form: {
        title: null,
        details: null,
      },
    };
  },
  methods: {
    update() {
      this.$emit('updated', this.form);
    },
  },
  created() {
    if (this.data != undefined && this.data != null) {
      this.form = this.data;
    }
  },
};
</script>

<style lang="less" scoped>
.submission-update-dialog {
  padding: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/abstract/tabs/dialog/SubmissionDialog.vue